import useNewsCritics from "hooks/useNewsCritics";
import { useCallback, useMemo } from "react";
const useClearNewsListButton = ({ isDisabled = false, isLoading = false, serviceName }) => {
    const { clear, setList, setNextCursor, state } = useNewsCritics();
    const serviceState = state[serviceName];
    const isServiceEmpty = useMemo(() => !serviceState.display.length &&
        !serviceState.selected.id &&
        !serviceState.nextCursor, [
        serviceState.display.length,
        serviceState.nextCursor,
        serviceState.selected.id
    ]);
    const onClick = useCallback(() => {
        clear(serviceName);
        setList([], serviceName);
        setNextCursor(null, serviceName);
    }, [clear, serviceName, setList, setNextCursor]);
    return useMemo(() => ({
        isDisabled: isDisabled || isLoading || isServiceEmpty,
        label: "Clear",
        loading: false,
        onClick,
        secondary: true
    }), [isDisabled, isLoading, isServiceEmpty, onClick]);
};
export default useClearNewsListButton;
